import { render, staticRenderFns } from "./list-item-image.vue?vue&type=template&id=4117acaf&scoped=true&"
import script from "./list-item-image.vue?vue&type=script&lang=js&"
export * from "./list-item-image.vue?vue&type=script&lang=js&"
import style0 from "./list-item-image.vue?vue&type=style&index=0&id=4117acaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4117acaf",
  null
  
)

export default component.exports
import {QImg,QDialog,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg,QDialog,QCard,QCardSection})
